// ==============================|| THEME CONSTANT ||============================== //

import 'assets/fonts/ALS_Sirius_Bold_0.95.otf'
export const APP_DEFAULT_PATH = '/main';
export const DRAWER_WIDTH = 300;
export const MINI_DRAWER_WIDTH = 60;


const config = {
  fontFamily: `'ALS_Sirius', sans-serif`
};

export default config;
